export const inputClass =
  'mt-1 w-full rounded-xl border border-brand-border bg-brand-dark px-3 py-2 text-sm text-white outline-none focus:border-brand-gold/50';

export const labelClass = 'block text-xs uppercase tracking-[0.15em] text-slate-400';

export const btnPrimary =
  'rounded-full bg-brand-gold px-5 py-2 text-sm font-semibold text-slate-950 hover:bg-brand-goldLight disabled:opacity-50';

export const btnGhost =
  'rounded-full border border-brand-border px-5 py-2 text-sm text-slate-300 hover:border-brand-gold/40';
